export type StopBannerState =
  | { kind: 'awaitingValidation'; effectiveAt?: string }
  | { kind: 'scheduled'; effectiveAt?: string; cancellableUntil: string }
  | { kind: 'requested'; effectiveAt?: string };

// effectiveAt is the requested date, never executesAt = max(stopDate, now + undo window)
export const resolveStopBanner = ({
  effectiveAt,
  executesAt,
  awaitingValidation,
}: {
  effectiveAt?: string;
  executesAt?: string;
  awaitingValidation: boolean;
}): StopBannerState => {
  if (awaitingValidation) {
    return { kind: 'awaitingValidation', effectiveAt };
  }
  // No executesAt means no execution is booked: the stop is already written to the policy.
  return executesAt
    ? { kind: 'scheduled', effectiveAt, cancellableUntil: executesAt }
    : { kind: 'requested', effectiveAt };
};

/** Undefined once the window has closed, so a past instant never formats as a live countdown. */
export const remainingCancelWindow = ({
  state,
  now,
}: {
  state: StopBannerState;
  now: number;
}): string | undefined =>
  state.kind === 'scheduled' && new Date(state.cancellableUntil).getTime() > now
    ? state.cancellableUntil
    : undefined;
